<div #dropdown class="autocomplete-dropdown">
  <ng-content></ng-content>
</div>
